import { useEffect } from "react"

import { Box } from "@chakra-ui/react"

import { useAppSelector } from "app/hooks"
import CustomMenuItem from "components/menudropdown/dropdown-menu-item"
import MenuDropDown from "components/menudropdown/menudropdown"
import { apiClient } from "services/client"
import { selectCurrentPmc } from "store/auth/authSlice"

type PropertyStateDropdownPropType = {
  stateList: string[]
  setStateList: React.Dispatch<React.SetStateAction<string[]>>
  selectedState: string
  setSelectedState: React.Dispatch<React.SetStateAction<string>>
}

const PropertyStateDropdown = (props: PropertyStateDropdownPropType) => {
  const { stateList, setStateList, selectedState, setSelectedState } = props
  const currentPmc = useAppSelector(selectCurrentPmc)

  // to get state list on page change
  useEffect(() => {
    if (currentPmc?.pmc_id) {
      apiClient
        .getStates({
          params: {
            pmcId: currentPmc?.pmc_id || "",
          },
        })
        .then((response) => {
          if (response.data.apiStatus === "SUCCESS") {
            setStateList(["ALL", ...response.data.data])
          }
          return true
        })
        .catch(() => {})
      setSelectedState("ALL")
    }
  }, [currentPmc?.pmc_id]) // don't need to add any other dependency

  return stateList?.length > 1 ? (
    <Box minW='100px'>
      <MenuDropDown title={selectedState} width='100%'>
        {stateList.map((state) => (
          <CustomMenuItem
            key={state}
            value={state}
            onClick={() => {
              setSelectedState(state)
            }}
            isSelected={state === selectedState}
          >
            {state}
          </CustomMenuItem>
        ))}
      </MenuDropDown>
    </Box>
  ) : (
    <div />
  )
}

export default PropertyStateDropdown
